<router-outlet></router-outlet>
<app-unsaved-changes-modal></app-unsaved-changes-modal>
<div class="pabsolute mail-popin-cont w100 h100">
  <div class="prelative dflex w100 h100">
    @for (emailData of mailService.emailsData$ | async; track emailData) {
      <app-mail-popin
        [emailData]="emailData"
        [reduced]="emailData.reduced"
        (closeAction)="closeMailPopin(emailData.id)"
        (isReduced)="closeAllEmailWindowsExcept(emailData.id)"
      ></app-mail-popin>
    }
  </div>
</div>
